import ViewPadrao from "../views/ViewPadrao";
import CnabList from "../views/CnabList";
import CnabCad from "../views/CnabCad";

export default {
  path: "cnab",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "cnab-list",
      component: CnabList
    },
    {
      path: "novo",
      name: "cnab-formulario",
      component: CnabCad
    },
    {
      path: "editar/:id",
      name: "cnab-formulario-editar",
      component: CnabCad
    }
  ]
};
